import React from 'react';
import ReactDOM from 'react-dom/client'; // ✅ Importe createRoot depuis 'react-dom/client'
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));


window.WebSocket = function() {
  console.error("WebSocket bloqué !");
  return { close: () => {} }; // Renvoie un objet bidon pour éviter les erreurs
};

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

